export default __webpack_public_path__ + "static/media/tab03-m_title01.0cc60e3a.png";